import React from 'react';
import {Chip} from '@mui/material';

const gatePassTypeStyles = {
    "Single Entry": {backgroundColor: '#e0efff', color: '#1565c0'},
    "Multi Entry": {backgroundColor: '#f1eaff', color: '#7e57c2'},
    "Annual": {backgroundColor: '#8B5CF6', color: '#fff'},
    "Special Entry": {backgroundColor: '#ff6f00', color: '#fff'},
}

const gatePassStatusStyles = {
    "For Approval": {backgroundColor: '#e3f2fd', color: '#2196f3'},
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Suspended": {backgroundColor: '#fff4e5', color: '#ff9800'},
    "Denied": {backgroundColor: '#ffebee', color: '#f44336'},
    "Deactivated": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
    "Inactive": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
}

const vehicleStatusStyles = {
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Deactivated": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
    "Suspended": {backgroundColor: '#fff4e5', color: '#ff9800'},
    "Removed": {backgroundColor: '#ffebee', color: '#f44336'},
}

const deviceStatusStyles = {
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Deactivated": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
    "Pending": {backgroundColor: '#FEF9C3', color: '#854D0E'},
}

const bookingStatusStyles = {
    "Draft": {backgroundColor: '#F3F4F6', color: '#1F2937'},
    "Pending for Approval": {backgroundColor: '#FEF9C3', color: '#854D0E'},
    "Scheduled": {backgroundColor: '#DBEAFE', color: '#1976d2'},
    "Cancelled": {backgroundColor: '#FDEAEA', color: '#D32F2F'},
    "Overdue": {backgroundColor: '#FFEDD5', color: '#9A3412'},
    "Completed": {backgroundColor: '#e8f5e9', color: '#068B1F'},
    "Rejected": {backgroundColor: '#FEE2E2', color: '#991B1B'}, 
}

const organizationStatusStyles = {
    "Approved": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Disapproved": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
    "Pending": {backgroundColor: '#FEF9C3', color: '#854D0E'},
}

const containerStatusStyles = {
    "In Port": {backgroundColor: '#F3F4F6', color: '#1F2937'},
    "In Transit": {backgroundColor: '#FEF9C3', color: '#854D0E'},
    "Scheduled": {backgroundColor: '#DBEAFE', color: '#1976d2'},
    "In CY/CD": {backgroundColor: '#e8f5e9', color: '#068B1F'},
    "Out of Port": {backgroundColor: '#FFEDD5', color: '#9A3412'},
    "Decommissioned": {backgroundColor: '#FDEAEA', color: '#D32F2F'},
} 

const portStatusStyles = {
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Deactivated": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
}

const vehicleEntryTypeStyles = {
    "Gate In": {backgroundColor: "#D1FAE5", color: "#065F46"},
    "Gate Out": {backgroundColor: "#DBEAFE", color: "#1E40AF"}, 
}

const profileStatusStyles = {
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Deactivated": {backgroundColor: '#ffebee', color: '#f44336'}, 
    "Pending": {backgroundColor: '#FEF9C3', color: '#854D0E'},
}

const userStatus = {
    "Active": {backgroundColor: '#e8f5e9', color: '#4caf50'},
    "Deactivated": {backgroundColor: '#F3F4F6', color: '#6B7280'}, 
}

const CustomChipComponent = ({label, category}) => {
    let style = {backgroundColor: '#e0e0e0', color: '#000'};

    if (category === "gatePassType" && gatePassTypeStyles[label]) {
        style = gatePassTypeStyles[label];

    } else if (category === "gatePassStatus" && gatePassStatusStyles[label]) {
        style = gatePassStatusStyles[label];

    } else if (category === "vehicleStatus" && vehicleStatusStyles[label]) {
        style = vehicleStatusStyles[label];

    } else if (category === "bookingStatus" && bookingStatusStyles[label]) {
        style = bookingStatusStyles[label];

    } else if (category === "deviceStatusStyles" && deviceStatusStyles[label]) {
        style = deviceStatusStyles[label];

    } else if (category === "organizationStatus" && organizationStatusStyles[label]) {
        style = organizationStatusStyles[label];

    } else if (category === "containerStatus" && containerStatusStyles[label]) {
        style = containerStatusStyles[label];

    } else if (category === "portStatus" && portStatusStyles[label]) {
        style = portStatusStyles[label];

    } else if (category === "vehicleEntryTypeStatus" && vehicleEntryTypeStyles[label]) {
        style = vehicleEntryTypeStyles[label];
    }

     else if (category === "profileStatusStyles" && profileStatusStyles[label]) {
        style = profileStatusStyles[label];
    }

    else if (category === "userStatus" && profileStatusStyles[label]) {
        style = profileStatusStyles[label];
    }


    return (
        <Chip
            label={label}
            style={{
                backgroundColor: style.backgroundColor,
                color: style.color,
                borderRadius: 20,
                fontWeight: 600,
                padding: "0 4px",
                width: "fit-content",
                alignItems: "center"
            }}
        />
    )
}

export default CustomChipComponent

